// extracted by mini-css-extract-plugin
export default {"buttons":"app-lists-ListSingle-ListSingle-module__FOM2ROyMy72nJIv8ccOe"};